import React from 'react';
import { Separator } from 'Common/Components/CustomActionBar/styled';
import { Wrapper, Tabs, Tab } from './styled';

const ExploreTabs = ({
  activeTab, setActiveTab, vulnCount, assetsCount, servicesCount
}) => {
  const getTabLabel = (label, count) => {
    if (typeof count !== 'number') return `${label}:`;
    return `${label}: ${count}`;
  };

  const vulnerabilitiesLabel = getTabLabel('Vulnerabilities', vulnCount);
  const assetsLabel = getTabLabel('Assets', assetsCount);
  const servicesLabel = getTabLabel('Services', servicesCount);

  return (
    <Wrapper>
      <Tabs>
        <Tab active={ activeTab === 0 } onClick={ () => setActiveTab(0) }>{vulnerabilitiesLabel}</Tab>
        <Separator />
        <Tab active={ activeTab === 1 } onClick={ () => setActiveTab(1) }>{assetsLabel}</Tab>
        <Separator />
        <Tab active={ activeTab === 2 } onClick={ () => setActiveTab(2) }>{servicesLabel}</Tab>
      </Tabs>
    </Wrapper>
  );
};

export default ExploreTabs;
